import { useBootstrapApiBase } from '../api';
import { CREDIT_USAGE_DISPLAY_ORDER, CreditUsageTitle } from '../constants';
import { CreditUsage, CreditUsageType } from '../definition';

const creditUsageDisplayRank = (key: CreditUsageType) => {
  const index = CREDIT_USAGE_DISPLAY_ORDER.indexOf(key);
  return index === -1 ? CREDIT_USAGE_DISPLAY_ORDER.length : index;
};

interface UseCreditUsageItemsReturn {
  items: CreditUsage[];
  isLoading: boolean;
}

export function useCreditUsageItems(
  filterArr?: CreditUsageType[]
): UseCreditUsageItemsReturn {
  const api = useBootstrapApiBase();

  if (!api.data?.cost) {
    return { items: [], isLoading: api.isLoading };
  }

  const items = (Object.keys(api.data.cost) as CreditUsageType[])
    .filter((key) => key in CreditUsageTitle)
    .filter((key) => (filterArr ? filterArr.includes(key) : true))
    .sort((a, b) => creditUsageDisplayRank(a) - creditUsageDisplayRank(b))
    .map((key) => ({
      credit: api.data?.cost[key],
      title: CreditUsageTitle[key],
      type: key,
    }));

  return { items, isLoading: api.isLoading };
}
